import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { colors } from '@styles/colors';

// Componente reutilizable para inputs
const Input = ({ placeholder = '', color = colors.inputBg, value, onChange, ancho = '66.3vh', nombre = null, onIconClick, ...props }) => {
  const mostrarBuscar = typeof props.icono === 'string' && props.icono.toLowerCase() === 'buscar';
  return (
    <div style={{
      position: 'relative',
      width: ancho,
      height: '6.2vh'
    }}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: color,
          borderRadius: '4vh',
          transform: 'rotate(0deg)',
          opacity: 1,
          border: 'none',
          outline: 'none',
          paddingLeft: '2.4vh',
          paddingRight: mostrarBuscar ? '6vh' : '2.4vh',
          fontSize: '2.35vh',
          fontFamily: 'Inter',
          fontWeight: 700,
          color: colors.accent,
          boxSizing: 'border-box'
        }}
        {...props}
      />
      {mostrarBuscar && (
        <div
          onClick={onIconClick}
          style={{
            position: 'absolute',
            right: '1vh',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '3.6vh',
            height: '3.6vh',
            backgroundColor: colors.primary,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}
        >
          <SearchIcon
            style={{
              color: colors.white,
              fontSize: '2.0vh'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Input;